<template>
  <div class="hstack align-items-center gap-2 mb-2">
    <b>{{ t("js.result_progress.status") }}:</b>
    <span class="me-2">{{ t(`js.result_progress.states.${resultOrchestrator.status}`) }}</span>
  </div>

  <ResultOrchestratorProgress
    :id="`result_orchestrator_${resultOrchestrator.id}`"
    :result-orchestrator="resultOrchestrator"
    class="mb-5"
  />

  <table class="table table-borderless">
    <thead>
      <tr>
        <th>
          <AVIcon icon="user" />
          {{ t("activerecord.models.e2e/trustee.one") }}
        </th>
        <th><AVIcon icon="shuffle" />
          {{ t("js.result_progress.states.mixing") }}
        </th>
        <th><AVIcon icon="key" />
          {{ t("js.result_progress.states.decrypting") }}
        </th>
      </tr>
    </thead>
    <tbody>
      <ResultOrchestratorWorkingTrustee
        v-for="trustee in trustees"
        :key="`trustee_${trustee.id}_${trustee.email}`"
        :trustee="trustee"
        :result-orchestrator="resultOrchestrator"
        :threshold="threshold"
        :is-active="Number(activeTrustee) === trustee.id"
      />
    </tbody>
  </table>
</template>

<script setup lang="ts">
import ResultOrchestratorProgress from "@/components/backend/result_orchestrator/ResultOrchestratorProgress.vue";
import ResultOrchestratorWorkingTrustee from "@/components/backend/result_orchestrator/ResultOrchestratorWorkingTrustee.vue";
import { useI18n } from "vue-i18n";
import { ref, computed } from "vue";
import type {
  PropType,
  ElectaTrustee,
  E2E,
  WorkflowState,
} from "@/types";

const { t } = useI18n();

const props = defineProps({
  trustees: {
    type: Array as PropType<Array<ElectaTrustee>>,
    required: true,
  },
  resultOrchestrator: {
    type: Object as PropType<E2E.ResultOrchestrator>,
    required: true,
  },
  threshold: {
    type: Number,
    required: true,
  },
});

const inProgressStatus = ref<Array<WorkflowState>>(["starting", "mixing", "decrypting", "validating"]);

const activeTrustee = computed(() =>
  props.resultOrchestrator.mixingPackages?.find(mixPackage => inProgressStatus.value.includes(mixPackage.status))?.trusteeUUID);
</script>
